import {createContext, useCallback, useContext} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const UsersApiContext = createContext(null);

export function UsersApiProvider({ children}) {

    const { get, post, patch, del } = useApiService(CONFIG.SERVER_ORGANIZATION);

    const getUsers = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/users?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
        }
    }, [get]);

    const getUserById = useCallback(async (userId) => {
        try {
            const response = await get(`/v1/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching user by ID:", error);
            throw error;
        }
    }, [get]);

    const createUser = useCallback(async (user) => {
        try {
            const response = await post(`/v1/users`, user);
            return response.data;
        } catch (error) {
            console.error("Error creating user:", error);
            throw error;
        }
    }, [post]);

    const changeUserPassword = useCallback(async (userId, password) => {
        try {
            const response = await post(`/v1/users/${userId}/change_password`, password);
            return response.data;
        } catch (error) {
            console.error("Error changing user password:", error);
            throw error;
        }

    }, [post]);

    const sendResetPasswordEmail = useCallback(async (email) => {
        try {
            const response = await post(`/v1/users/send_reset_password_email`, { email });
            return response.data;
        } catch (error) {
            console.error("Error sending reset password email:", error);
            throw error;
        }
    }, [post]);

    const updateUser = useCallback(async (userId, user) => {
        try {
            const response = await patch(`/v1/users/${userId}`, user);
            return response.data;
        } catch (error) {
            console.error("Error updating user:", error);
            throw error;
        }
    }, [patch]);

    const deleteUser = useCallback(async (userId) => {
        try {
            const response = await del(`/v1/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting user:", error);
            throw error;
        }
    }, [del]);

    return (
        <UsersApiContext.Provider value={{
            getUsers,
            getUserById,
            createUser,
            changeUserPassword,
            sendResetPasswordEmail,
            updateUser,
            deleteUser,
        }}>
            {children}
        </UsersApiContext.Provider>
    );
}

export function useUsersApi() {
    const context = useContext(UsersApiContext);
    if (!context) {
        throw new Error("useUserApi must be used within a UsersApiProvider");
    }
    return context;
}